import React from 'react'
import { Svg } from './styles'

export const LogoW = props => (
  <Svg viewBox="0 0 100 100" {...props}>
    <path d="M2.2 17.6l19.4 64.7H40L21.1 17.6zM59.4 82.3L49.6 50l-5.5 18-9.4-31.6 5.7-18.9 19 .1 18.7 64.7zM78.6 17.5h18.6L82.2 67l-9.3-30.1z"/>
  </Svg>
)
